import React from 'react';
import { FaExclamationTriangle, FaRedo } from 'react-icons/fa';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4 bg-[#020617]">
          <div className="max-w-md w-full bg-[#0f172a] border border-[#ef4444] p-8">
            <div className="flex items-center justify-center mb-6">
              <FaExclamationTriangle className="text-[#ef4444] text-5xl" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-4 text-center" style={{ fontFamily: 'Manrope' }}>
              Something Went Wrong
            </h2>
            <p className="text-[#94a3b8] text-center mb-6">
              An unexpected error occurred. Please try refreshing the page.
            </p>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="bg-[#020617] border border-[#1e293b] p-4 mb-6 overflow-auto">
                <pre className="text-xs text-[#ef4444] whitespace-pre-wrap">
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </div>
            )}
            
            <button
              onClick={this.handleReset}
              className="w-full bg-[#ccff00] text-black font-bold uppercase tracking-wider text-sm px-8 py-3 hover:bg-[#b3e600] transition-all flex items-center justify-center"
              style={{ fontFamily: 'Manrope' }}
            >
              <FaRedo className="mr-2" /> Reload Application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;